module.exports = __webpack_public_path__ + "static/media/imge-8.31a69fd7.jpg";